<div class="flex flex-col bg-card overflow-hidden">
  <div class="light:bg-cool-gray-100 dark:bg-cool-gray-700 pl-3 pr-3 pt-4 pb-4 border-b flex items-center">
    <div class="flex flex-col">
      <div class="font-bold text-md text-secondary uppercase tracking-wider">{{ panelDef.title }}</div>
    </div>
    <div class="ml-auto">
      <mat-progress-spinner *ngIf="loading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
    </div>
  </div>
  <div class="flex flex-col max-h-120 overflow-y-auto">
    <table
      class="w-full bg-transparent"
      mat-table
      matSort
      [dataSource]="nearbyProjects$ | async"
      [trackBy]="trackByFn"
      #addressTable
    >
      <ng-container matColumnDef="title">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"> Name </span>
        </th>
        <td mat-cell *matCellDef="let project">
          <div class="title-content">
            <span class="thumbnail">
              <a [routerLink]="['/projects/' + project.pipeline_id + '/' + project.id + '/details/overview']"
                ><img *ngIf="project.featured_image_url" [src]="project.featured_image_url"
              /></a>
              <span *ngIf="!project.featured_image_url"> No Image </span>
            </span>
            <span class="title"
              ><a [routerLink]="['/projects/' + project.pipeline_id + '/' + project.id + '/details/overview']">{{
                project.title
              }}</a></span
            >
          </div>
        </td>
      </ng-container>

      <!-- Date -->
      <ng-container matColumnDef="address">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"> Address </span>
        </th>
        <td mat-cell *matCellDef="let project">
          <div class="pr-6 whitespace-nowrap">
            {{ project.address_string }}
          </div>
        </td>
      </ng-container>

      <!-- Name -->
      <ng-container matColumnDef="type">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"> Type </span>
        </th>
        <td mat-cell *matCellDef="let project">
          <span class="pr-6 whitespace-nowrap">
            {{ project.property_type?.name }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr class="order-row h-16" mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </div>
</div>
